var _rect, _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationTracking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 57,
    viewBox: "0 0 66 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 57,
    rx: 12,
    fill: "#FEC10D",
    fillOpacity: 0.16
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.0002,
    cy: 29.3307,
    r: 2.66667,
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.0002,
    cy: 29.3307,
    r: 2.66667,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9331 27.3974L37.6664 24.6641",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9331 27.3974L37.6664 24.6641",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5335 38.6675C21.5385 35.4922 19.9888 30.1375 21.6704 25.3193C23.352 20.501 27.897 17.2734 33.0002 17.2734C38.1034 17.2734 42.6484 20.501 44.33 25.3193C46.0116 30.1375 44.4619 35.4922 40.4669 38.6675H25.5335Z",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5335 38.6675C21.5385 35.4922 19.9888 30.1375 21.6704 25.3193C23.352 20.501 27.897 17.2734 33.0002 17.2734C38.1034 17.2734 42.6484 20.501 44.33 25.3193C46.0116 30.1375 44.4619 35.4922 40.4669 38.6675H25.5335Z",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationTracking);
export default __webpack_public_path__ + "static/media/application_tracking.4b7a46cf4f624e0b168d38f3715164aa.svg";
export { ForwardRef as ReactComponent };